import { Event } from '../Event'
import { ViewerContext } from '../../constants'
import { ArticleEntryPoint } from './types'

export interface ArticleEntryPointClickedEventProperties {
  article_id: string
  entry_point: ArticleEntryPoint
}

export class ArticleEntryPointClickedEvent extends Event<ArticleEntryPointClickedEventProperties> {
  static displayName = 'Article Entry Point Clicked'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
